import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class CustomScrollbarService {
    
    onScrollTarget(event: Event) {
        //console.log(event);
    }
}